import React, { useEffect, useState } from "react";
import { HttpStatusCode } from "axios";
import { useNavigate } from "react-router-dom";

import { logout } from "../../../services/authServices";
import {
  PublicTermPurpose,
  agreementPurpose,
} from "../../../services/etcServices";

import useAgreement from "../../../hooks/useAgreement";
import useSimplePopup from "../../../hooks/useSimplePopup";

import CommonPopup from "..";
import CommonButton from "../../Button";
import TermsPopup from "../Terms";

type Props = { popup?: string; onSuccess: () => void, onClose?: () => void };

export default function EssentialTermPopup({ popup, onSuccess, onClose }: Props) {
  const [termPopup, setTermPopup] = useState<string>("");
  const [terms, setTerms] = useState<PublicTermPurpose | "">("");
  const navigate = useNavigate();
  const [simplePopupComponent, { open }] = useSimplePopup({});
  const agreementList = [
    {
      title: "개인정보 수집 및 이용 동의",
      required: true,
      onClick: () => {
        setTermPopup("showTerms");
        setTerms("personal_gather");
        return true;
      },
      value: "personal_gather",
    },
    {
      title: "서비스 이용약관 동의",
      required: true,
      onClick: () => {
        setTermPopup("showTerms");
        setTerms("service");
        return true;
      },
      value: "service",
    },
    {
      title: "위치기반 이용약관 동의",
      required: true,
      onClick: () => {
        setTermPopup("showTerms");
        setTerms("location");
        return true;
      },
      value: "location",
    },
    {
      title: "마케팅 처리 방침",
      required: false,
      onClick: () => {
        setTermPopup("showTerms");
        setTerms("marketing");
        return true;
      },
      value: "marketing",
    },
    {
      title: "혜택/이벤트 알림(PUSH)",
      required: false,
    },
  ];
  const [{ isComplete, reset, agreements }, sandiAgreementComponent] =
    useAgreement({
      allTitle: "전체동의",
      agreementList,
    });

  useEffect(() => {
    if (popup === "") {
      reset();
    }
  }, [popup]);

  const handleRequest = async () => {
    try {
      const result = await agreementPurpose({
        agreedPurpose: agreementList
          .filter((item, index) => agreements[index] && item.value)
          .map((item) => item.value ?? ""),
        advertise: agreements[4],
      });
      if (result.status === HttpStatusCode.Ok) {
        await onSuccess();
        navigate("/view");
      } else {
        open("권한 동의에 실패했습니다.", {
          onClick: () => {
            logout();
            onClose?.();
          },
        });
      }
    } catch (e: any) {
      if (e?.response?.data?.error) {
        open(e.response.data.error?.replace(". ", ".\n"), {
          onClick: () => {
            logout();
            onClose?.();
          },
        });
      } else {
        open("권한 동의에 실패했습니다.", {
          onClick: () => {
            logout();
            onClose?.();
          },
        });
      }
    }
  }

  return (
    <>
      <CommonPopup
        isOpen={popup === "essentialTerms"}
        title="샌디 이용 권한 동의"
        padding={0}
        unUseHorizonRule
      >
        {sandiAgreementComponent}
        <div className="flex">
          <CommonButton
            variant="grey"
            className="bottom-button w-[100px]"
            onClick={() => {
              logout();
              onClose?.();
            }}
          >
            취소
          </CommonButton>
          <CommonButton
            className="bottom-button"
            disabled={!isComplete}
            onClick={handleRequest}
          >
            권한 동의
          </CommonButton>
        </div>
      </CommonPopup>

      <TermsPopup
        popup={termPopup}
        onClose={() => setTermPopup("")}
        type={terms as PublicTermPurpose}
      />
      {simplePopupComponent}
    </>
  );
}
